//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { tabsScroll } from '@/common/mixins/tabsScroll'
export default {
    mixins: [
        tabsScroll({
            bottom_active: 64,
            scroll_padding_left: 20
        })
    ]
}
